<template>
  <header>
    <span class="mikon" id="logo">
      <router-link :to="{name:'home'}">
        <img src="../assets/img/logo.png" alt="log1" />
      </router-link>
    </span>
    <span class="mikon" id="hamb">
      <a href="#" @click.prevent="showMenu = !showMenu">
        <img src="../assets/img/hamburger.png" alt="hamburger" />
      </a>
    </span>
    <span class="mikon" id="szukaj">
      <img src="../assets/img/lupa.png" alt="szukaj" />
    </span>
    <section id="bokmenu" v-bind:class="{ bokwprawo: showMenu }" @click="showMenu=false">
      <button @click="showMenu=false">X</button>
      <router-link :to="{name:'calculator'}">Kalkulator weselny</router-link>
      <router-link :to="{name:'ofertaWeselna'}">Oferta weselna</router-link>
      <router-link :to="{name:'cateringWinny'}">Catering winny</router-link>
      <a href="#">Zestawy upominkowe</a>
      <a href="#">Zaprojektuj kartkę</a>
      <a href="#">Zaprojektuj etykietę</a>
      <a href="#">Prezent na ślub</a>
      <a href="#">Upominki dla gości</a>
      <router-link :to="{name:'alkoholNaWieczorPanienski'}">Alkohol na wieczór panieński</router-link>
      <router-link :to="{name:'alkoholNaWieczorKawalerski'}">Alkohol na wieczór kawalerski</router-link>
      <a href="#">Kosze prezentowe dla rodziców</a>
      <router-link :to="{name:'doradztwoWeselne'}">Doradztwo weselne</router-link>      
      <router-link :to="{name:'sklepDobrewino'}">Sklep dobrewino</router-link>
    </section>
    <div  v-bind:class="{ taflabackground: showMenu }" @click="showMenu=false" />
  </header>
</template>

<script>
export default {
  name: "navbar",

  data() {
    return {
      showMenu: false
    };
  }
};
</script>

<style scoped>
@import "./Navbar.css";
</style>
